import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * List icon for overview/list functionality
 */
export const ListIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path d="M4 6h16M4 10h16M4 14h16M4 18h16" />
    </Icon>
  );
};

export default ListIcon;
